module.exports = __webpack_public_path__ + "static/ud_crafted-45d73ecb2f44147899c7f23fd6896a5a.svg";